import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // Changed to BrowserRouter
import App from "./App";
import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import * as Sentry from "@sentry/react";
import { Suspense } from "react";
import './i18n'; // Import the i18n configuration


Sentry.init({
  dsn: "https://8c91e363d17b37c0b8632c74e410f3a7@o4507091058950144.ingest.de.sentry.io/4507091103121488",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    /^https:\/\/web.rebidd\.com/,
    /^https:\/\/web-dev.rebidd\.com/,
    /^https:\/\/web-staging.rebidd\.com/,
    /^https:\/\/web.gohome\.rent/,
    /^https:\/\/web-dev.gohome\.rent/,
    /^https:\/\/web-staging.gohome\.rent/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

Sentry.setTag("enviroment", process.env.REACT_APP_ENVIRONMENT);

const container = document.getElementById("root") as Element;
const root = ReactDOM.createRoot(container);

root.render(
  <BrowserRouter>
    <I18nextProvider i18n={i18next}>
      <Suspense>
        <App />
      </Suspense>
    </I18nextProvider>
  </BrowserRouter>,
);
